import {useRef} from 'react';

import {isNotNil} from 'ramda';

import {useOnMount} from 'shared/web';

interface AutoHideProps {
  delayMs: number;
  onElapsed: () => void;
}

/**
 * Renders nothing and fires `onElapsed` once after `delayMs`. Mount it with a `key` that changes
 * with the thing being timed, so a new state restarts the countdown instead of inheriting it.
 */
export function AutoHide(props: AutoHideProps) {
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useOnMount(
    () => {
      timeoutRef.current = setTimeout(props.onElapsed, props.delayMs);
    },
    () => {
      if (isNotNil(timeoutRef.current)) {
        clearTimeout(timeoutRef.current);
      }
    }
  );

  return null;
}
